import teaser from '../../data/wrack-teaser.json';
import type { AppDef } from '../../types/window';
import type { WrackTeaser } from '../../types/content';
import { el } from './dom';

const copy = teaser as WrackTeaser;

export const wrackApp: AppDef = {
  appId: 'wrack',
  title: "Wrack 'n Crack",
  icon: 'wrack',
  defaultSize: { w: 500, h: 380 },
  singleton: true,
  mount(root) {
    const wrap = el('div', { className: 'app-stack' });
    wrap.append(
      el('h1', { text: copy.title }),
      el('p', { text: `${copy.year} · ${copy.logline}` }),
    );
    for (const p of copy.paragraphs) wrap.append(el('p', { text: p }));
    wrap.append(el('p', { text: copy.statusLine }), el('p', { text: copy.footerNote }));
    root.replaceChildren(wrap);
    return () => root.replaceChildren();
  },
};
